import { render, staticRenderFns } from "./confirmPay.vue?vue&type=template&id=ccbfb1f6&scoped=true"
import script from "./confirmPay.vue?vue&type=script&lang=js"
export * from "./confirmPay.vue?vue&type=script&lang=js"
import style0 from "./confirmPay.vue?vue&type=style&index=0&id=ccbfb1f6&prod&scoped=true&lang=css"
import style1 from "./confirmPay.vue?vue&type=style&index=1&id=ccbfb1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbfb1f6",
  null
  
)

export default component.exports